'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processFile = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.processFiles = processFiles;

var _files = require('helpers/files');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processFile = exports.processFile = {
  dropbox: function dropbox(file) {
    var processedFile = (0, _extends3.default)({}, file);
    processedFile.__type = processedFile['.tag'];
    processedFile.__id = processedFile.id;
    processedFile.__name = processedFile.name;
    processedFile.__ext = (0, _files.getFileExtention)(processedFile.name);
    return processedFile;
  },

  boxcom: function boxcom(file) {
    var processedFile = (0, _extends3.default)({}, file);
    processedFile.__type = processedFile.type;
    processedFile.__id = processedFile.id;
    processedFile.__name = processedFile.name;
    processedFile.__ext = processedFile.extension || '';
    return processedFile;
  }
};

function processFiles(files, service) {
  if (files) {
    var processedFiles = [];
    files.map(function (file) {
      return processedFiles.push(processFile[service](file));
    });
    return processedFiles;
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/cloud.js
// module id = 2227
// module chunks = 1